module.exports = "<div class=\"h5 mt-2\">\n    <small>\n        Deliver by: {{ctrl.deliverBy}}\n    </small>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/deliverBy.html
// module id = 762
// module chunks = 0